export const iconFontAwesomeSpinnersAsterisk = (
	<i className="fa-solid fa-asterisk"></i>
);
